var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBook = function SvgBook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M18.602 2a1.54 1.54 0 0 1 1.54 1.541v16.94a1.54 1.54 0 0 1-1.54 1.541H6.837a2.954 2.954 0 0 1-2.939-2.66l-.013-.292V4.952A2.954 2.954 0 0 1 6.837 2zM6.837 17.317a1.754 1.754 0 0 0-1.753 1.753l.009.173a1.754 1.754 0 0 0 1.744 1.58h11.765a.343.343 0 0 0 .341-.342v-3.164zm0-14.118a1.754 1.754 0 0 0-1.753 1.753v11.746a2.95 2.95 0 0 1 1.753-.58h12.106V3.54a.34.34 0 0 0-.341-.342z"
  })));
};
export default SvgBook;